
const _checkResponse = async (response) => {
  if (response.status === 401 || response.status === 403) {
    // window.location.href=process.env.REACT_APP_BACKEND_URL + '/logout';
    window.location.href='/app/logout';
  } else if (response.ok) {
    const response_json = await response.json();
    return response_json;
  }
  console.log("Network error, got response code " + response.status);
  alert("The application has encountered a problem. Please try again later");
};


const doPut = async (url, params) => {
  const options = {
    method: "PUT",
    body: JSON.stringify(params),
    credentials: "include"
  };
  // const response = await fetch(process.env.REACT_APP_BACKEND_URL + url, options);
  const response = await fetch('/app' + url, options);
  return _checkResponse(response);
};


const doPost = async (url, params) => {
  const options = {
    method: "POST",
    body: JSON.stringify(params),
    credentials: "include"
  };
  // const response = await fetch(process.env.REACT_APP_BACKEND_URL + url, options);
  const response = await fetch('/app' + url, options);
  return _checkResponse(response);
};

const doGet = async (url) => {
  const options = {
    credentials: "include"
  }
  // const response = await fetch(process.env.REACT_APP_BACKEND_URL + url, options)
  const response = await fetch('/app' + url, options)
  return _checkResponse(response);
}

const doFormPost = async (url, form) => {
  const response = await fetch('/app' + url, {method:'post', body: new FormData(form)});
  return _checkResponse(response);
};

export default doGet;
export {doPost, doGet, doPut, doFormPost};
